import React, { memo } from 'react';
import { Linkedin, Twitter, Mail } from 'lucide-react';
import { AnimatedSection } from './AnimatedSection';
export function TeamSection() {
  const teamMembers = [{
    name: 'Dan Knight',
    role: 'Co-Founder & CEO',
    bio: "Dan is a software engineer turned revenue operator. After years building products at high-growth startups, he ran events as a go-to-market motion and watched sales leaders treat them as an unbudgetable line item. He realized the problem was not the events. It was that nobody could forecast them. So he built Turnout to make events a channel you can price, run, and measure.",
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/puQfL52NJjm2xZfDkLctHA/1744810493288_%281%29.jpg',
    social: {
      linkedin: 'https://www.linkedin.com/in/dan-c-knight/',
      twitter: 'https://x.com/turnout_info',
      email: 'dan@turnout.info'
    }
  }, {
    name: 'Jordan Zax',
    role: 'Co-Founder & CTO',
    bio: 'Jordan Zax is the Co-Founder and CTO of Turnout. He previously spent over three years at Palo Alto Networks building enterprise-grade systems and holds his M.S. and B.S. from Northwestern University. Jordan leads engineering and product development.',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/1pyF3DYVn7xKC9QrAED7EL/1748397385106.jpg',
    social: {
      linkedin: 'https://www.linkedin.com/in/jordan-zax/',
      twitter: 'https://x.com/turnout_info',
      email: 'dan@turnout.info'
    }
  }];
  return <section id="team" className="py-20 bg-gray-50" data-id="element-298" data-mp="2hy5zuclm7dl2">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-299" data-mp="243lsisqwkejc">
        <AnimatedSection data-id="element-300" data-mp="293rmwgok4f54">
          <div className="text-center mb-16" data-id="element-301" data-mp="292yfddhrxllx">
            <h2 className="text-3xl font-extrabold text-gray-900 sm:text-4xl" data-id="element-302" data-mp="291nafacle7t8">
              Meet Our Team
            </h2>
            <p className="mt-4 max-w-2xl text-xl text-gray-600 mx-auto" data-id="element-303" data-mp="31k2eclofnvdb">
              The team turning events into a forecastable revenue channel.
            </p>
          </div>
        </AnimatedSection>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 max-w-4xl mx-auto" data-id="element-304" data-mp="36h7r36rupujk">
          {teamMembers.map((member, index) => <AnimatedSection key={index} delay={index * 0.2} data-id="element-305" data-mp="31gtwaqf9gh3h" data-mpi={index}>
              <div className="bg-white rounded-xl overflow-hidden shadow-sm hover:shadow-md transition-all duration-300 h-full border border-gray-100" data-id="element-306" data-mp="2wj0pbv64vj25">
                <div className="aspect-w-3 aspect-h-4 relative" data-id="element-307" data-mp="2siq6hhx8sy5v">
                  <img src={member.image} alt={member.name} className="w-full h-80 object-cover object-center" data-id="element-308" data-mp="2nq6ugpe7eb36" />
                </div>
                <div className="p-8 flex flex-col" data-id="element-309" data-mp="2dtbvy6hxkaow">
                  <h3 className="text-2xl font-bold text-gray-900" data-id="element-310" data-mp="2dqg2aud48869">
                    {member.name}
                  </h3>
                  <p className="text-indigo-600 font-medium mb-4 text-lg" data-id="element-311" data-mp="24r2pbrps91gs">
                    {member.role}
                  </p>
                  <p className="text-gray-600 mb-6 flex-grow leading-relaxed" data-id="element-312" data-mp="k8s65z4afbf3">
                    {member.bio}
                  </p>
                  <div className="flex space-x-5 mt-auto" data-id="element-313" data-mp="oczx82y7x3gh">
                    <a href={member.social.linkedin} target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-indigo-600 transition-colors" aria-label={`${member.name}'s LinkedIn profile`} data-id="element-314" data-mp="tbjl48wdgpbh">
                      <Linkedin size={20} data-id="element-315" data-mp="5ib2sa83ebfk" />
                    </a>
                    <a href={member.social.twitter} target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-indigo-600 transition-colors" aria-label={`${member.name}'s Twitter profile`} data-id="element-316" data-mp="ai5xkouznl5w">
                      <Twitter size={20} data-id="element-317" data-mp="1ojbs9nqaxied" />
                    </a>
                    <a href={`mailto:${member.social.email}`} className="text-gray-400 hover:text-indigo-600 transition-colors" aria-label={`Email ${member.name}`} data-id="element-318" data-mp="1ojlincf9drkl">
                      <Mail size={20} data-id="element-319" data-mp="1thwqxipwnu0p" />
                    </a>
                  </div>
                </div>
              </div>
            </AnimatedSection>)}
        </div>
      </div>
    </section>;
}